export default __webpack_public_path__ + "static/media/curiosity.ded0433f.svg";